(function () {
	Vue.component('nominow-input-select', {
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			value: {
				// Value can be any: String, Object, Array, Number, etc.
			},
			label: {
				type: String
			},
			required: {
				type: Boolean,
				required: false
			},
			css: {
				type: String,
				required: false
			},
			options: {
				type: Array,
				required: true,
				default: () => []
			},
			nomui: {
				type: Boolean,
				required: false
			}
		},
		data: function () {
			return {
				emit: true,
				placeholder: '-- choose --',
				id: `select${new Date().getTime()}`,
				select: {},
				selectedValue: null
			};
		},
		created: function () {
			this.selectedValue = this.value;
		},
		watch: {
			value: function (newVal) {
				this.emit = false;
				this.selectedValue = newVal;
				this.emit = true;
			},
			selectedValue: function () {
				if (this.emit) {
					this.$emit('change', this.selectedValue);
				}
			}
		},
		template: `
        <div class="field" :class="{'mui-textfield' : (!nomui)}">
            <label v-if="label">{{label}}</label>
            <div :id="id" class="field">
                <div class="select is-light">
                    <select v-model="selectedValue">
                        <option v-if="placeholder && !required" value="">{{placeholder}}</option>
                        <option v-for="option in options" :value="option.key">{{option["value"]}}</option>
                    </select>
                </div>
            </div>
        </div>
        `,
		methods: {}
	});
})();
